import { render, staticRenderFns } from "./CustomerForm4473Login.vue?vue&type=template&id=44975282&scoped=true"
import script from "./CustomerForm4473Login.vue?vue&type=script&lang=js"
export * from "./CustomerForm4473Login.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm4473Login.vue?vue&type=style&index=0&id=44975282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44975282",
  null
  
)

export default component.exports